export const iframe = {
  url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3347.7753049104617!2d-96.72344314922748!3d32.956941282003044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c1f1158509693%3A0xe66952a940ed0a3f!2sTrastar%20Inc!5e0!3m2!1sen!2sus!4v1637482056157!5m2!1sen!2sus",
};
